import React from 'react';
import PropTypes from 'prop-types';
import { flatten } from 'lodash';
import Spinner from '../shared/Spinner';

import { title, value } from './translations';

const FOUR_FACTORS = ['efg', 'orr', 'ftr', 'tov'];
const SHOOTING_EFFICIENCY = [
  'fg_perc',
  'fg3_perc',
  'fg2_perc',
  'ft_perc',
  'fg3_par',
  'pps',
  'true_shooting',
];
const PACE = ['possessions_per_game', 'points_per_possession', 'points'];
const ASSISTS = ['assist_percentage', 'ato'];

const STATS_GROUPS = {
  four_factors: FOUR_FACTORS,
  shooting_efficiency: SHOOTING_EFFICIENCY,
  pace: PACE,
  assists: ASSISTS,
};

const TeamRateStats = ({ stats }) => {
  return (
    <section className="s-advanced-stats__data s-advanced-stats__rate">
      {stats ? (
        [
          <div key="team-rate" className="stats-table__fixed-container">
            <div className="stats-table__container">
              <table className="stats-table">
                <TableHeader />
                <TableBody stats={stats} />
              </table>
            </div>
          </div>,
          <Legend key="legend" />,
        ]
      ) : (
        <Spinner />
      )}
    </section>
  );
};

TeamRateStats.propTypes = {
  stats: PropTypes.object,
};

export default TeamRateStats;

const Legend = () => (
  <div className="legend">
    <div className="legend-item-container">
      <div className="legend-item">
        <div className={`legend-color four-factors`} />
        <div className="legend-text">Four Factors</div>
      </div>
    </div>
  </div>
);

const TableHeader = () => (
  <thead>
    <tr>
      <th></th>
      <th className="stats-table__column-title">TEAM</th>
      <th className="stats-table__column-title">OPPONENT</th>
    </tr>
  </thead>
);

const TableBody = ({ stats }) => (
  <tbody>
    {getFullStatsList().map(({ groupKey, stat }) => (
      <TableStatRow
        key={`${groupKey}-${stat}`}
        stats={stats}
        groupKey={groupKey}
        stat={stat}
      />
    ))}
  </tbody>
);

const TableStatRow = ({ stats, groupKey, stat }) => {
  const teamValue = stats.team.calculated[groupKey][stat];
  const opponentValue = stats.opponent.calculated[groupKey][stat];

  let isTeamBetter = teamValue >= opponentValue;
  let isOpponentBetter = opponentValue >= teamValue;

  if (stat === 'tov') {
    isTeamBetter = teamValue <= opponentValue;
    isOpponentBetter = opponentValue <= teamValue;
  }

  let fourFactorsClass =
    FOUR_FACTORS.indexOf(stat) !== -1 ? 'four-factors' : '';

  return (
    <tr className={fourFactorsClass}>
      <th className="stats-table__row-title" title={title(stat)}>
        {title(stat)}
      </th>

      <td title={title(stat)} className={isTeamBetter ? 'highlight' : ''}>
        {value(stat, teamValue)}
      </td>

      <td title={title(stat)} className={isOpponentBetter ? 'highlight' : ''}>
        {value(stat, opponentValue)}
      </td>
    </tr>
  );
};

function getFullStatsList() {
  return flatten(
    Object.keys(STATS_GROUPS).map(groupKey =>
      STATS_GROUPS[groupKey].map(stat => ({
        groupKey,
        stat,
      })),
    ),
  );
}
